var storelocatorurl = (lang == 'en') ? 'storelocator' : 'tiendas';

$(document).ready(function () {
    $("#homestorelocatorsearch").submit(function (e) {
        e.preventDefault();
        var oValidation = new Validation();
        if (!oValidation.IsEmpty($('#homelocatorfield').val())) {
            trackingFloodlight('storelocatorsearch');
            trackGA4(this, 'home_locatorsearch');
            setTimeout(function () {
                window.location = '/' + storelocatorurl + '?address=' + escape($('#homelocatorfield').val());
            }, 500);
        }
    });

    //closing the disclaimer box via the close button within it
    $("#disclaimerClose").on('click', function () {
        $('.disclaimer-wrap').removeClass('slide-up');
        $('.disclaimer-wrap').addClass('slide-down');
        $('.disclaimer-wrap').attr("aria-hidden", "true");
        //if ($('#' + lastid)) {
        //    $('#' + lastid).focus();
        //}
    })

    $("#disclaimerClose").on('keydown', function (e) {
        var key = e.which;
        //console.log(key)
        if (key == 13 || key == 27)  // the enter key code or escape key
        {
            $('.disclaimer-wrap').removeClass('slide-up');
            $('.disclaimer-wrap').addClass('slide-down');
            $('.disclaimer-wrap').attr("aria-hidden", "true");
            //if ($('#' + lastid)) {
            //    $('#' + lastid).focus();
            //}
        }
        if (key == 9) {
            e.preventDefault();
        }
    })


    //$(window).on('scroll', function () {
    //    setTimeout(function () {
    //        $('.disclaimer-wrap').removeClass('slide-up');
    //        $('.disclaimer-wrap').addClass('slide-down');
    //        $('.disclaimer-wrap').attr("aria-hidden", "true");
    //        if ($('#' + lastid)) {
    //            $('#' + lastid).focus();
    //        }
    //    }, 300);

    //})

})

var showpanodisclaimer = function () {
    $('.disclaimer-wrap').removeClass('slide-down');
    $('.disclaimer-wrap').addClass('slide-up');
    $('.disclaimer-wrap').attr("aria-hidden", "false");
}

var usemylocation = function () {
    trackingFloodlight('storelocatorsearch');
    trackGA4(this, 'home_usemylocation');
    setTimeout(function () {
        window.location = '/' + storelocatorurl + '?um=1';
    }, 500);
}
